var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.maxStars')
    }
  }, [_c('el-input-number', {
    staticClass: "hide-spin-button",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1,
      "max": 10
    },
    model: {
      value: (_vm.optionModel.max),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "max", $$v)
      },
      expression: "optionModel.max"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1be01b61","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-rate/rate-max-editor.vue
// module id = null
// module chunks = 